import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header className="bg-black text-white py-4 relative">
      <div className="container mx-auto px-4 flex justify-between items-center rounded-lg">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <img 
              src="/logos/logo.png" 
              alt="$100K Agency" 
              className="h-8 md:h-10 w-auto object-contain" 
              style={{ 
                maxWidth: '100%',
                filter: 'drop-shadow(0 0 2px rgba(255, 255, 255, 0.2))'
              }}
            />
          </Link>
        </div>
        
        <nav className="hidden md:flex space-x-6">
          {/* Contact link removed */}
        </nav>
        
        <Link 
          to="/contact" 
          className="bg-primary hover:bg-purple-700 text-white px-4 py-2 rounded-md font-medium transition-all animate-pulse-glow"
          style={{ 
            animation: 'pulse-glow 3s ease-in-out infinite'
          }}
        >
          Work With Us
        </Link>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-primary/10 via-primary to-primary/10"></div>
    </header>
  );
};

export default Header; 